import { gsap } from "gsap";
import Cookies from "js-cookie";

function CookiesBanner() {
    const cookiesBannerElement = document.getElementById("cookies-banner");
    const cookiesAcceptButton = document.getElementById("cookies-accept-button");
    const cookie = "cookies-accepted";
    const hideBanner = () => gsap.to(cookiesBannerElement, { height: 0, duration: 0.3, display: "none" });
    const showBanner = () =>
        gsap.to(cookiesBannerElement, { height: "auto", duration: 0.3, display: "block", delay: 0.3 });

    if (cookiesBannerElement) {
        if (Cookies.get(cookie)) {
            cookiesBannerElement.classList.add("hide");
        } else {
            showBanner();
        }
    }

    if (cookiesAcceptButton) {
        cookiesAcceptButton.addEventListener("click", () => {
            Cookies.set(cookie, true, { expires: 365 });
            hideBanner();
        });
    }
}

export default CookiesBanner;
